import { useEffect, useState } from 'react';
import { useAdvancedSecurity } from './useAdvancedSecurity';

export const useAntiCheat = () => {
  const [violations, setViolations] = useState([]);
  const { isFullscreen, isTabVisible, warnings, requestFullscreen } = useAdvancedSecurity();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent common keyboard shortcuts
      if (
        (event.ctrlKey && (
          event.key === 'c' || // Copy
          event.key === 'v' || // Paste
          event.key === 'p' || // Print
          event.key === 's' || // Save
          event.key === 'u' || // View Source
          event.key === 'a'    // Select All
        )) ||
        event.key === 'F12' || // Developer Tools
        (event.altKey && event.key === 'Tab') // Alt+Tab
      ) {
        event.preventDefault();
        setViolations(prev => [...prev, {
          type: 'keyboard_shortcut',
          key: event.key,
          timestamp: new Date().toISOString()
        }]);
      }
    };

    const handleContextMenu = (event) => {
      event.preventDefault();
      setViolations(prev => [...prev, {
        type: 'right_click',
        timestamp: new Date().toISOString()
      }]);
    };

    const handleCopy = (event) => {
      event.preventDefault();
      setViolations(prev => [...prev, {
        type: 'copy_attempt',
        timestamp: new Date().toISOString()
      }]);
    };

    const handlePaste = (event) => {
      event.preventDefault();
      setViolations(prev => [...prev, {
        type: 'paste_attempt',
        timestamp: new Date().toISOString()
      }]);
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('paste', handlePaste);
    };
  }, []);

  return {
    violations,
    warnings,
    isFullscreen,
    isTabVisible,
    requestFullscreen
  };
}; 